import { render, staticRenderFns } from "./PointPaymentDescription.vue?vue&type=template&id=7a5927c3&scoped=true"
import script from "./PointPaymentDescription.vue?vue&type=script&lang=js"
export * from "./PointPaymentDescription.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a5927c3",
  null
  
)

export default component.exports